import { useBoolean } from 'react-use'

import { AIEmojisAPI } from '@makyoapp/makyo-sdk'
import { MaterialIconPicker, MaterialIconSetting } from '@makyoapp/makyo-ui'

import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'

interface IconFieldSettingProps {
  id: string
  settingId: string
  value: any
}

const IconFieldSetting = ({ id, settingId, value }: IconFieldSettingProps) => {
  const [showIcon, setShowIcon] = useBoolean(false)
  const updateValue = useUpdateCompSettingValue(id)
  const clickAsDone = true
  const toggleClassName = 'flex-cc rounded-sm bg-zinc-200 dark:bg-slate-600 w-9 h-9'

  const handleToggle = () => setShowIcon(true)

  const handleClear = async () => {
    await updateValue(undefined)
  }

  const handleClose = () => {
    setShowIcon(false)
  }

  const handleSearchFilter = async (keyword: string) => {
    const aiSearch = await AIEmojisAPI.ReqFindEmoji(keyword)
    return aiSearch
  }

  const settings = {
    fill: 0,
    opsz: 24,
    wght: 300,
    grade: 0,
  }

  return (
    <MaterialIconPicker
      show={showIcon}
      id={settingId}
      value={value as string}
      clickAsDone={clickAsDone}
      onToggle={handleToggle}
      toggleClassName={toggleClassName}
      toggle={
        value === '' || value === undefined
          ? (active, toggleProps) => {
              return <div {...toggleProps}>+</div>
            }
          : undefined
      }
      onClear={handleClear}
      onClose={handleClose}
      searchMs={300}
      searchFilter={async (keyword) => {
        const aiSearch = await AIEmojisAPI.ReqFindEmoji(keyword)
        return aiSearch
      }}
      onDone={updateValue}
      settings={settings as MaterialIconSetting}
      portalMenu
    />
  )
}

export default IconFieldSetting
